import { render } from "./SpellBasicConfig.vue?vue&type=template&id=1eb76ab2&scoped=true"
import script from "./SpellBasicConfig.vue?vue&type=script&lang=js"
export * from "./SpellBasicConfig.vue?vue&type=script&lang=js"

import "./SpellBasicConfig.vue?vue&type=style&index=0&id=1eb76ab2&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eb76ab2"]])

export default __exports__